/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useEffect, useRef, useState, useContext } from "react";
import CardHeader from '../../../../components/CardHeader';
import UpdateButton from '../../../../components/UpdateButton';
import Toast from '../../../../components/Toast';
import CustomOverLay from '../../../../components/CustomOverlay';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import { dataService } from '../../../../services/data.services';
import moment from 'moment';
import { distributeAmounts, distributeDivision } from '../Components/AddStudentComponents/distributeDivisionFeeTerm';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FeeStructureDetails from "./FeeStructureDetails";
import StudentList from "./StudentList";
import InvoicePreview from "./InvoicePreview";
import GlobalContext from '../../../../components/Context/GloablContext'

const UpdateFeeStructure = () => {
    const [searchParams] = useSearchParams();
    const isEdit = searchParams.get("is_edit");
    const [initialLoadDone, setInitialLoadDone] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);
    const [feeStructureLoading, setFeeStructureLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);
    const [actionButton, setActionButton] = useState("Next");
    const [toastErrorMessage, setToastErrorMessage] = useState("");
    const [academicYears, setAcademicYears] = useState([]);
    const [academicYearDropdownOpen, setAcademicYearDropdownOpen] = useState(false);
    const [selectedAcademicYear, setSelectedAcademicYear] = useState("");
    const [classes, setClasses] = useState([]);
    const [classDropdownOpen, setClassDropdownOpen] = useState(false);
    const [selectedClass, setSelectedClass] = useState("");
    const [sectionDropdownOpen, setSectionDropdownOpen] = useState(false);
    const [sections, setSections] = useState([])
    const [selectedSection, setSelectedSection] = useState("");
    const [sectionLoading, setSectionLoading] = useState(false)
    const [academicYearLoading, setAcademicYearLoading] = useState(false);
    const [classLoading, setClassLoading] = useState(false);
    const [feeStructure, setFeeStructure] = useState([]);
    const [didAcademicDropDownChange, setAcademicDidDropDownChange] = useState(false)
    const [feeTerm, setFeeTerm] = useState([])
    const [selectedDropDownValue, setSelectedDropDownValue] = useState('');
    const [selectedFeeTermData, setSelectedFeeTermData] = useState({});
    const [selectedTermLength, setSelectedTermLength] = useState(0);
    const [didDropDownChange, setDidDropDownChange] = useState(false);
    const [hasStartDateBegun, setHasStartDateBegun] = useState(false);
    const [isSelectFeeTermDropdown, setIsSelectFeeTermDropdown] = useState(false);
    const [submitSelected, setsubmitSelected] = useState(false);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const {setToastmessage}=useContext(GlobalContext)
    const navigate = useNavigate();
    const voucherSteps = [
        { key: "step:1", label: "Select Fee Structure" },
        { key: "step:2", label: "Assign to Students" },
        { key: "step:3", label: "Invoice Issue Summary" },
    ];
    const [currentTab, setCurrentTab] = useState('step:1'); // Default tab

    const getAcademicYears = async () => {
        try {
            setAcademicYearLoading(true); // start loading
            const branch_id = await GetBranchId();
            let endpoint = `academic-years?branch_id=${branch_id}&filter=true&status=ongoing,upcoming,completed`;
            const response = await dataService.GetAPI(endpoint);
            const temp = response?.data?.data?.data;
            setAcademicYears(temp);
            // getFilterData(temp);
            return temp; // Returning academic years data 
        } catch(error){
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally {
            setAcademicYearLoading(false); // stop loading
        }
    };
    const getClasses = async () => {
        try {
            setClassLoading(true); // start loading
            const branch_id = await GetBranchId();
            let endpoint = `classes?branch_id=${branch_id}&filter=true&status=true&role=directory`;
            const response = await dataService.GetAPI(endpoint, true);
            const temp = response.data?.data?.data;
            setClasses(temp);
        } catch (error) {
            console.log(error);
            setToastErrorMessage(
                error?.response?.data?.message || "Something went wrong"
            );
        } finally {
            setClassLoading(false); // stop loading
        }
    };
    const handleAcademicYearDropdownToggle = () => {
        setClassDropdownOpen(false);
        setSectionDropdownOpen(false);
        setAcademicYearDropdownOpen(!academicYearDropdownOpen);
    };
    const handleClassDropdownToggle = () => {
        setAcademicYearDropdownOpen(false);
        setSectionDropdownOpen(false);
        setClassDropdownOpen(!classDropdownOpen);
    };

    const handleSectionDropdownToggle = () => {
        setClassDropdownOpen(false);
        setAcademicYearDropdownOpen(false);
        setSectionDropdownOpen(!sectionDropdownOpen);
    };
    const onAcademicYearChange = (academicYear) => {
        setInitialLoadDone(true);
        setAcademicDidDropDownChange(true);
        setSelectedAcademicYear(academicYear);
    };

    const onClassChange = (classItem) => {
        setInitialLoadDone(true);
        setSelectedClass(classItem);
        //clear section selection
        setSelectedSection("");
        setsubmitSelected(false);
    };

    const onSectionChange = (section) => {
        setSelectedSection(section);
    };

    const callSectionAPI = async () => {
        setSectionLoading(true);
        if(selectedAcademicYear?.name!==undefined&&selectedClass?.name!==undefined)
        {const branch_id = await GetBranchId();
            let endpoint = `associations?branch_id=${branch_id}&academic_year_id=${selectedAcademicYear?._id}&class_id=${selectedClass?._id}&filter=true&role=directory`;
            const response = await dataService.GetAPI(endpoint, true);
            const temp = response.data?.data?.data;
            setSections(
                temp.map((obj) => {
                    return {
                        name: obj.section_name,
                        id: obj.section_id,
                        subjects: obj.subjects,
                    };
                })
            );
        }  
        setSectionLoading(false);
    }
    useEffect(() => {
        if (selectedAcademicYear?.name != "" && selectedClass?.name != "") {
            callSectionAPI()
            setSectionDropdownOpen()
            //setSectionsLoading(true)
            //(studentAcademicDetails?.sections?.section_name)
        }
    }, [selectedAcademicYear?.name, selectedClass?.name]);

    const getFeeStructure=async()=>{
        try{
            if (
                // hasStartDateBegun ||
                selectedAcademicYear?.academic_year_id === "" ||
                selectedClass?.class_id === "" ||
                sectionLoading
            ) return;
            if(isEdit && !initialLoadDone) return;
            console.log("Fetching fee structure with:")
            setFeeStructureLoading(true)
            const branch_id = await GetBranchId()
            // const selectedOptionalSubjectsIDs = selectedObjects.map(extractId);
            let body = {
                "branch_id":branch_id,
                "academic_year_id": selectedAcademicYear?._id,
                "class_id": selectedClass?._id,
                "status": true,
                "role" : "directory",
            }
            // if (selectedOptionalSubjectsIDs.length) {
            //     body.optional_subject_checked = selectedOptionalSubjectsIDs;
            // }
            if (selectedAcademicYear !== null) {
                console.log("Fetching fee structure withclskksls:");
                let endpoint = `fee-structures/students-fee-structure`
                const response = await dataService.PostAPI(body, endpoint)
                if((response.data?.data?.data?.length===0)){
                    setSelectedDropDownValue('') 
                }
                const temp=(response.data?.data?.data)
                setFeeStructure(temp)
                isEdit && initialLoadDone && setSelectedDropDownValue("");
            }
        } catch {
            setFeeStructureLoading(false)
        } finally {
            setFeeStructureLoading(false)
        }
    }
    
    const getFeeTerm = async()=>{
        if (feeStructureLoading) return
        const branch_id = await GetBranchId()
        let endpoint = `feeterms?branch_id=${branch_id}&academic_year=${selectedAcademicYear.name}&filter=true&status=true&role=directory`;
        const response = await dataService.GetAPI(endpoint, true)
        const temp=(response.data?.data?.data)
        setFeeTerm(
            temp.map((obj) => {
                return {
                    name: obj.fee_term_name,
                    id: obj._id,
                    number_of_fee_terms: obj.number_of_fee_terms,
                    terms: obj.terms,
                };
            })
        );
    }
    const handleDropDownValue = (key, item)=>{
        setSelectedDropDownValue(item?.name)

        //calculate termfee using distributeAmounts
        const terms = item?.terms?.map((term, index) => {
            return {
                term_name: `Term ${index + 1}`,
                fee_head: feeStructure[0].fees?.map((feeHead) => ({
                    fee_head_name: feeHead.fee_head,
                    fee_head_id: feeHead?.fee_head_id,
                    fee_head_amount: parseFloat(
                        distributeDivision(
                            feeHead.amount,
                            item.number_of_fee_terms,
                            item.number_of_fee_terms
                        )[index]
                    ).toFixed(2),
                })),
                term_amount: parseFloat(
                    distributeAmounts(
                        feeStructure[0]?.fees,
                        item.number_of_fee_terms,
                        "amount",
                        index
                    )
                ).toFixed(2),
                start_date: term.start_date,
                end_date: term.end_date,
            };
        });
        const updatedItem = {
            ...item,
            terms: terms,
        };
        console.log("Updated Item:", updatedItem);
        setSelectedFeeTermData(updatedItem);
        setSelectedTermLength(item?.number_of_fee_terms);
        setDidDropDownChange(true);
        setHasStartDateBegun(false);
        setIsSelectFeeTermDropdown(true);
    }

    const handleTabs = (key) => {
        if (key === 'step:1') {
            setActionButton('Next');
        }

        if (key === 'step:2') {
            if (!handleStep1Validation()) {
                setLoadingButton(false);
                return
            }
            setActionButton('Next');
        }
        else if (key === 'step:3') {
            if (!handleStep1Validation()) {
                setLoadingButton(false);
                return
            }
            if (!handleStep2Validation()) {
                setLoadingButton(false);
                setsubmitSelected(true);
                return
            }
            setActionButton('Update');
        }
        setCurrentTab(key);
    }

    const handleStep1Validation = () => { 
        setsubmitSelected(true);
        if (selectedAcademicYear === "" || selectedClass === "" || selectedSection === "") {
            setToastErrorMessage("Please fill all mandatory fields");
            return;
        }
        
        if (feeStructure.length === 0) {
            setToastErrorMessage("No Fee Structure found for the selected AY and class");
            return;
        }

        if(selectedDropDownValue === ""){
            setToastErrorMessage("Please select a fee term");
            return;
        }
        return true;
    }

    const handleStep2Validation = () => {
        if(selectedStudents.length===0){
            setToastErrorMessage("Please select at least one student to proceed");
            return false;
        }
        return true;
    }
    
    useEffect(() => {
        getAcademicYears();
        getClasses();
    }, []);

    // Step 2: Flip initialLoadDone AFTER first paint
    useEffect(() => {
        // your existing logic
        if (isEdit && !initialLoadDone ) {
            console.log("Skipping API calls on first load when editing");
            return;
        } 
        if (selectedAcademicYear && selectedClass) {
            getFeeStructure();
        }
    }, [selectedAcademicYear, selectedClass]);

    useEffect(() => {
        if (didAcademicDropDownChange) {
            getFeeTerm();
        }
    }, [didAcademicDropDownChange]);

    const handleOnchangeInput = (id, option) => {
        if(id==="academic_year"){
            onAcademicYearChange(option);
            handleAcademicYearDropdownToggle();
        }
        else if(id==="class"){
            onClassChange(option);
            handleClassDropdownToggle();
        }
        else if(id==="section"){
            onSectionChange && onSectionChange(option);
            handleSectionDropdownToggle();
        }
        else if(id==="fee-term-dropdown"){
            handleDropDownValue("fee_term_name", option);
            setIsSelectFeeTermDropdown(false);
        }
    };


    const handleSubmit = async (e) => {
        try {
            let currentTab1 = currentTab;
            let newTabNum = Number(currentTab1.split(':')[1]) + 1
            let newTab = "step:" + newTabNum;

            if (newTab === 'step:2' || newTab === 'step:3') {
                handleTabs(newTab);
                return;
            }
            if (newTab === 'step:4') {
                
                if (!handleStep1Validation()) {
                    setLoadingButton(false);
                    return
                }
                if (!handleStep2Validation()) {
                    setLoadingButton(false);
                    setsubmitSelected(true);
                    return
                }
                setLoadingButton(true);
                const branch_id = await GetBranchId();
                let body = {
                    branch_id: branch_id.toString(),
                    academic_year: {
                        name: selectedAcademicYear?.name || "",
                        start_date: selectedAcademicYear?.start_date || "",
                        end_date: selectedAcademicYear?.end_date || "",
                        "academic_year_id": selectedAcademicYear?._id || "",
                    },
                    classes: { "class_name": selectedClass.name, "class_id": selectedClass._id } || "",
                    sections: { "section_name": selectedSection.name, "section_id": selectedSection.id } || "",
                    students: selectedStudents.map((student) => ({
                        student_uuid: student._id,
                        student_id: student.student_id,
                        student_name: student.full_name,
                    })),
                    fee_structure: [],
                    fee_term_id: selectedFeeTermData?.id || "",
                };
                const result = [];
                feeStructure?.length !== 0 &&
                    feeStructure[0]?.fees.forEach((item) => {
                        result?.push({
                            feehead_name: item?.fee_head.trim(),
                            feehead_amount: item?.amount,
                            fee_head_id: item?.fee_head_id,
                        });
                    });

                if (result.length !== 0) {
                    body["fee_structure"] = {
                        fee_head: result,
                        total_amount: feeStructure[0]?.cumulative_amount.toString(),
                    };
                }
                const mappedData = [];
                selectedFeeTermData?.terms?.map((term, index) => {
                    // Check if the term is a future term
                    const isFutureTerm = moment(term?.end_date.split("T")[0]).isAfter(
                        moment()
                    );
                    if (!isFutureTerm) return; // Skip past terms

                    const terms = selectedFeeTermData?.terms;

                    const mappedTerm = {
                        feeterm_name: selectedFeeTermData.name,
                        term_name: term?.term_name,
                        fee_head: terms?.[index]?.fee_head?.map((feeHead) => ({
                            fee_head_name: feeHead.fee_head,
                            fee_head_id: feeHead?.fee_head_id,
                            amount: parseFloat(feeHead.fee_head_amount).toFixed(2),
                        })),
                        total_amount: parseFloat(term?.term_amount).toFixed(2),
                        start_date: term.start_date,
                        end_date: term.end_date,
                    };
                    mappedData.push(mappedTerm);
                });
                body["fee_term"] = mappedData;
                body["fee_term_id"] = selectedFeeTermData?.id || "";

                const response = await dataService.PutAPI(body, `students/update-fee-structure`);
                
                if (response?.data?.statusCode === 200) {
                    setLoadingButton(false);
                    const params = Object.fromEntries(searchParams);

                    const updatedParams = {
                        ...params,
                        isBulkIssueTriggered: response?.data?.isBulkIssueTriggered,
                        transactionId: response?.data?.bulkTransactionId,
                        totalStudents: response?.data?.totalStudents,
                        isScheduleModal: true,
                        isOngoingTermExists: response?.data?.isOngoingTermExists
                    };
                    navigate(`/student-master/directory?${new URLSearchParams(updatedParams).toString()}`
                    );
                }
                else { 
                    setLoadingButton(false);
                    setActionButton("Update");
                    setToastErrorMessage(response?.data?.message || "Something went wrong");
                }
            }
        }
        catch (error) {
            console.log(error);
            setLoadingButton(false);
            setActionButton("Update");
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
    }

    return (
        <CardHeader noPadding classkey={"overflow-y-hidden"}>
            <div className="mainDataCntnrTop shadow-s13" style={{ position: "sticky", position: "-webkit-sticky" }}>
                <h5 className="pageHeader addclass">Update Fee Structure</h5>
                <div className="flex items-center">
                    <UpdateButton
                        ButtonName={"Cancel"}
                        loading={false}
                        handleOnCLick={() => { navigate("/student-master/directory"); }}
                        classKey="cancl-btn"
                    />
                    <UpdateButton
                        loading={loadingButton}
                        ButtonName={actionButton}
                        id={"update-fee-structure-next-btn"}
                        handleOnCLick={handleSubmit}
                        classKey={"actn-btn onboardInstitution"}
                    />
                </div>
                {toastErrorMessage !== '' && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>

            {loadingPage ? (
                <CustomOverLay
                    Active
                    text="Loading ..."
                    classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}
                />
            ) : 
                (
                    <div>
                        <div className='h-[calc(100vh-70px)]'>
                            <div class="overflow-y-auto scrollBar-hidden pt-[24px] pb-5">
                                <div className='flex justify-center border-b pb-[10px]'>
                                    <div>
                                        <div class="flex items-center justify-center">
                                            <div class="w-[30px] h-[30px] rounded-full border-[6px] border-[#106EB4] bg-[#fff] z-[1]"></div>
                                            <div class={`w-[150px] h-2 -mx-[1px] ${(currentTab === 'step:2' || currentTab === 'step:3') ? 'bg-[#106EB4] ' : 'bg-[#D9D9D9]'}`}></div>
                                            <div class={`w-[30px] h-[30px] rounded-full border-[6px] z-[1] ${(currentTab === 'step:2' || currentTab === 'step:3') ? 'border-[#106EB4]' : 'border-[#D9D9D9]'} bg-[#fff]`}></div>
                                            <div class={`w-[150px] h-2 -mx-[1px] ${(currentTab === 'step:3') ? 'bg-[#106EB4]' : 'bg-[#D9D9D9]'}`}></div>
                                            <div class={`w-[30px] h-[30px] rounded-full border-[6px] z-[1] ${(currentTab === 'step:3') ? 'border-[#106EB4]' : 'border-[#D9D9D9]'} bg-[#fff]`}></div>
                                        </div>
                                        <div class="flex justify-center">
                                            {voucherSteps.map((step, idx) => (
                                                <p onClick={() => { handleTabs(step.key); }}
                                                    key={step.key}
                                                    className={`pt-[7px] text-f7 cursor-pointer text-[#031624] w-[180px] text-center ${currentTab === step.key ? 'font-semibold' : ''}`}>
                                                    {step.label}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="overflow-auto scroll-bar min-h-minheight1 max-h-maxheight1 px-[40px]">
                                    <div class={`w-[80%] mx-auto mt-4 pb-[10px]`}>
                                        {currentTab === 'step:1' && (
                                            <FeeStructureDetails
                                                academicYears={academicYears}
                                                academicYearLoading={academicYearLoading}
                                                selectedAcademicYear={selectedAcademicYear}
                                                classes={classes}
                                                classLoading={classLoading}
                                                selectedClass={selectedClass}
                                                sections={sections}
                                                sectionLoading={sectionLoading}
                                                selectedSection={selectedSection}
                                                feeStructure={feeStructure}
                                                feeStructureLoading={feeStructureLoading}
                                                handleOnchangeInput={handleOnchangeInput}
                                                feeTerm={feeTerm}
                                                selectedDropDownValue={selectedDropDownValue}
                                                selectedFeeTermData={selectedFeeTermData}
                                            />
                                        )}
                                        {currentTab === 'step:2' && (
                                            <StudentList
                                                selectedStudents={selectedStudents}
                                                setSelectedStudents={setSelectedStudents}
                                                selectedAcademicYear={selectedAcademicYear}
                                                selectedClass={selectedClass}
                                                selectedSection={selectedSection}
                                                selectedFeeTermData={selectedFeeTermData}
                                            />
                                        )
                                        }
                                        {currentTab === 'step:3' && (
                                            <InvoicePreview
                                                selectedStudents={selectedStudents}
                                                setSelectedStudents={setSelectedStudents}
                                                selectedAcademicYear={selectedAcademicYear}
                                                selectedClass={selectedClass}
                                                selectedSection={selectedSection}
                                                selectedFeeTermData={selectedFeeTermData}
                                                selectedStudentsCount={selectedStudents.length}
                                            />
                                        )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </CardHeader>
    );
};

export default UpdateFeeStructure;
